// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/**\n * StylingButton.css — Static styles for StylingButton component\n */\n", "",{"version":3,"sources":["webpack://./src/components/StylingButton.css"],"names":[],"mappings":"AAAA;;EAEE","sourcesContent":["/**\n * StylingButton.css — Static styles for StylingButton component\n */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
